// extracted by mini-css-extract-plugin
module.exports = {"body":"ComparePlayers_body__3JE0P","title":"ComparePlayers_title__jLB-s","description":"ComparePlayers_description__2aJ_s"};